/**
 * created by xcc on 2022/2/21
 * 媒体管理接口
 */

import request from "../../../base/request";

let host = "/cm-sites-pms/media/";

const Apis = {
    getMediaTypeList: "/cm-sites-pms/mediaType/findAll", //媒体类型
    getDeptData: "/cm-sites-sys/dept/getTree", //所属部门树
    getDeptUserData: "/cm-sites-sys/user/conditionQuery", //所属部门用户列表
    getDeptUser: "/cm-sites-pms/website/getUsersAndBindVsbUser", //所属部门用户列表(绑定用户的)
    mediaAdministerAdd: host + 'add', //新增
    mediaAdministerUpdate: host + 'update', //修改
    mediaAdministerDel: host + 'deleteMedia', //删除
    getMediaAdministerData: host + 'mediaList', //媒体列表
    getMediaSortData: host + 'getSortMaxByDept', //媒体排序最大值
    getMediaCountData: host + 'mediaCount', //各媒体数量
    startOrDisableUsing: host + 'enable', //启用、禁用
    verifyAccount:'/cm-sites-pms/website/getUser',// 验证账号
    getWebSiteList: "/cm-sites-pms/website/getWebsiteList", //获取站点
    isOAuthSuccess: host + 'isOAuthSuccess',//获取是否认证
    verifyWechat: '/cm-sites-pms/material/saveAuth',//微信认证
    verifyWebsite: '/cm-sites-pms/website/saveAuth',//网站认证
    verifyBaiJiaHao: '/cm-sites-pms/baijiahao/saveAuth',//百家号认证
    confirmAdd: host + 'batchSaveMedia',//确定新增
    downLoadTemplate: host + 'exportMediaTemplate',//下载模板
    getSiteAddressData: '/cm-sites-pms/vsbManage/getAll',//站点地址数据
    updateSiteColumnTree: '/cm-sites-pms/website/synColumnTree',//更新网站栏目树
    saveSortData: host + 'mediaSort',//保存排序
}

export const getMediaTypeList = (body, callBack) => {
    request({url: Apis.getMediaTypeList, body, callBack});
};
export const getDeptData = (body, callBack) => {
    request({url: Apis.getDeptData, body, callBack});
};
export const getDeptUserData = (body, callBack) => {
    request({url: Apis.getDeptUserData, contentType: "json", method: "post", body, callBack});
};

export const getDeptUser = (body, callBack) => {
    request({url: Apis.getDeptUser, contentType: "json", method: "post", body, callBack});
};
export const mediaAdministerAdd = (body, callBack) => {
    request({url: Apis.mediaAdministerAdd, contentType: "json", method: "post", body, callBack});
};
export const mediaAdministerUpdate = (body, callBack) => {
    request({url: Apis.mediaAdministerUpdate, contentType: "json", method: "post", body, callBack});
};
export const mediaAdministerDel = (body, callBack) => {
    request({url: Apis.mediaAdministerDel, method: "post", body, callBack});
};
export const getMediaAdministerData = (body, callBack) => {
    request({url: Apis.getMediaAdministerData, body, callBack});
};
export const getMediaSortData = (body, callBack) => {
    request({url: Apis.getMediaSortData, body, callBack});
};
export const getMediaCountData = (body, callBack) => {
    request({url: Apis.getMediaCountData, body, callBack});
};
export const startOrDisableUsing = (body, callBack) => {
    request({url: Apis.startOrDisableUsing, body, callBack});
};
export const verifyAccount = (body, callBack, errorCallBack) => {
    request({
        url: Apis.verifyAccount,
        method: "post",
        body,
        callBack,
        message: {info: errorCallBack, error: errorCallBack}
    });
};
export const getWebSiteList = (body, callBack, errorCallBack) => {
    request({
        url: Apis.getWebSiteList,
        method: "post",
        body,
        callBack,
        message: {info: errorCallBack, error: errorCallBack}
    });
};
export const gotoOAuth = (body, callBack, mediaTypeCode) => {
    let url = "/cm-sites-pms/weibo/gotoOAuth";
    if(mediaTypeCode === "douyin"){
        url = "/cm-sites-pms/douyin/gotoOAuth";
    }else if(mediaTypeCode === "kuaishou"){
        url = "/cm-sites-pms/kuaishou/gotoOAuth";
    }
    request({url: url, body, callBack});
}
export const isOAuthSuccess = (body, callBack, errorCallBack, mediaTypeCode) => {
    let url = "/cm-sites-pms/weibo/isOAuthSuccess";
    if(mediaTypeCode === "douyin"){
        url = "/cm-sites-pms/douyin/isOAuthSuccess";
    }else if(mediaTypeCode === "kuaishou"){
        url = "/cm-sites-pms/kuaishou/isOAuthSuccess";
    }
    request({url: url, body, callBack, message: {info: errorCallBack, error: errorCallBack}});
}
export const verifyWechat = (body, callBack) => {
    request({url: Apis.verifyWechat, method: "post", body, callBack});
}
export const verifyWebsite = (body, callBack) => {
    request({url: Apis.verifyWebsite, contentType: "json", method: "post", body, callBack});
}
export const verifyBaiJiaHao = (body, callBack) => {
    request({url: Apis.verifyBaiJiaHao, method: "post", body, callBack});
}
export const confirmAdd = (body, callBack) => {
    request({url: Apis.confirmAdd, contentType: "json", method: "post", body, callBack});
}
export const downLoadTemplate = (body, callBack) => {
    request({url: Apis.downLoadTemplate, method: "downloadGet", body, callBack});
}
export const getSiteAddressData = (body, callBack) => {
    request({url: Apis.getSiteAddressData, body, callBack});
}
export const updateSiteColumnTree = (body, callBack) => {
    request({url: Apis.updateSiteColumnTree, body, callBack});
}
export const saveSortData = (body, callBack) => {
    request({url: Apis.saveSortData, contentType: "json", method: "post", body, callBack});
}